import { forwardRef, type ReactNode, type Ref } from 'react';
import clsx from 'clsx';
import styles from './CalloutBox.module.css';

type Props = {
  testid?: string;
  image?: ReactNode;
  className?: string;
  children: ReactNode;
};

/**
 * Modified from a similar component in app but the props and styles are applied differently
 */
export const CalloutBox = forwardRef(
  (props: Props, ref: Ref<HTMLDivElement>) => {
    const { testid, children, image, className } = props;
    return (
      <div
        data-testid={testid}
        className={clsx(styles.container, className)}
        ref={ref}
      >
        {image}
        {children}
      </div>
    );
  }
);
